/* eslint-disable */
import i18n from "../plugins/vue-i18n";

const layer1 = {
  Layer1Sample: {
    path: "/Sample/",
    code: "Sample/Sample",
    iconName: "iconfont icon-web-setting",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
};

const layer2 = {
  Layer2Sample: {
    path: "/Sample/Sample001/",
    code: "Sample/Sample001/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
};

const layer3 = {
  /* -------------------- 查詢 Start -------------------- */
  WENAG001: {
    path: "",
    code: "S32/S32W4006/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENAG002: {
    path: "",
    code: "S32/S32W4007/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENAG002_1: {
    path: "",
    code: "S32/S32W4008/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENAG005: {
    path: "",
    code: "S32/S32W1001/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENAG006: {
    path: "",
    code: "S32/S32W1002/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENAG008: {
    path: "",
    code: "S31/S31W4001/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENAG102: {
    path: "",
    code: "S31/S31W4002/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENAG156: {
    path: "",
    code: "S32/S32W1003/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENAG157: {
    path: "",
    code: "S32/S32W1004/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENAG203: {
    path: "",
    code: "S32/S32W1005/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENAG300: {
    path: "",
    code: "S32/S32W1006/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENAG301: {
    path: "",
    code: "S32/S32W1007/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENAG302: {
    path: "",
    code: "S32/S32W1008/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENAG303: {
    path: "",
    code: "S32/S32W1009/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENAG304: {
    path: "",
    code: "S32/S32W1010/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENAG305: {
    path: "",
    code: "S32/S32W4001/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENAG310: {
    path: "",
    code: "S32/S32W4002/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENAG315: {
    path: "",
    code: "S32/S32W4003/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENAG320: {
    path: "",
    code: "S32/S32W4004/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENAG321: {
    path: "",
    code: "S32/S32W4005/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENAG327_1: {
    /* AG327_01 */ path: "",
    code: "S31/S31W4003/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENAG327_2: {
    /* AG327_02 */ path: "",
    code: "S31/S31W4004/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENAG329_2: {
    /* AG329_02 */ path: "",
    code: "S31/S31W4005/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENAG330: {
    path: "",
    code: "S31/S31W4006/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENAG390: {
    path: "",
    code: "S31/S31W4007/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENAG391: {
    path: "",
    code: "S31/S31W4008/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENAK150: {
    path: "",
    code: "S43/S43W4001/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENAK151: {
    path: "",
    code: "S43/S43W4003/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENAK201: {
    path: "",
    code: "S43/S43W4005/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENAK302: {
    /*導師班學生查詢*/ path: "",
    code: "S41/S41W4009/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENAK307: {
    path: "",
    code: "S43/S43W4007/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENAK400: {
    path: "",
    code: "S40/S40W4001/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENAK430: {
    path: "",
    code: "S47/S47W4001/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENAK432: {
    path: "",
    code: "S47/S47W4003/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENZTE302: {
    path: "",
    code: "S55/S55W4001/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENZTE303: {
    path: "",
    code: "S55/S55W4002/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  /* -------------------- 查詢 End -------------------- */
  /* -------------------- 登錄/申請 Start -------------------- */
  WENZCP400: {
    path: "",
    code: "S56/S56W2001/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENZCP402: {
    path: "",
    code: "S56/S56W2002/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENZCP403: {
    path: "",
    code: "S56/S56W2003/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENZCP404: {
    path: "",
    code: "S56/S56W4003/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENZCP406: {
    path: "",
    code: "S56/S56W4004/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENCG300: {
    path: "",
    code: "S31/S31W2001/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENCG400: {
    path: "",
    code: "S30/S30W2002/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENCG410: {
    path: "",
    code: "S30/S30W2003/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENBG301: {
    path: "",
    code: "S30/S30W2001/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENBK300: {
    path: "",
    code: "S43/S43W2001/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WEN843Q: {
    path: "",
    code: "S43/S43W2002/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENCG020: {
    path: "",
    code: "S46/S46W2001/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENCK001: {
    path: "",
    code: "S41/S41W2001/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENCK400: {
    path: "",
    code: "S45/S45W2001/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WEN829: {  /*學習單 2025.11.21*/
    path: "",
    code: "S45/S45W2002/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENBG302: {
    path: "",
    code: "S40/S40W2001/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENBK010: {
    path: "",
    code: "S419/S419W2001/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENBG002: {
    path: "",
    code: "S30/S30W2007/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENBG003: {
    path: "",
    code: "S30/S30W2008/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENBK850: {
    path: "",
    code: "S41/S41W2005/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WEN812BQ: { /*S43W2004 導生輔導資料登錄 2026.4.8*/
    path: "",
    code: "S43/S43W2004/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WEN819Y: { /*學生缺曠更正申請單 2025.12.12*/
    path: "",
    code: "S41/S41W2006/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENZUA600: {
    path: "",
    code: "S1X/S1XW2001/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENCG420: {
    path: "",
    code: "S30/S30W2005/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENCG430: {
    path: "",
    code: "S30/S30W2006/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENBG004: {
    path: "",
    code: "S30/S30W2004/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENBG000_2: {
    path: "",
    code: "S33/S33W9002/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENBG005: {
    path: "",
    code: "S33/S33W9003/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENBG050: {
    path: "",
    code: "S33/S33W9004/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENBK012: {
    path: "",
    code: "S33/S33W9005/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENBK015: {
    path: "",
    code: "S33/S33W9006/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENZPE4991: {
    path: "",
    code: "S18/S18W2007/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENZTE300: {
    path: "",
    code: "S55/S55W2003/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENZTE301: {
    path: "",
    code: "S55/S55W2004/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENCK222: {
    path: "",
    code: "S41/S41W3001/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WEN80A: {
    /*特教生查詢*/ path: "",
    code: "S40/S40W4002/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  }, 
  WEN824Q: {
    /*學生個人缺曠請假明細表(原WEN824)*/ path: "",
    code: "S41/S41W4001/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WEN827Q: {
    /*學生個人獎懲狀況明細表(原WEN827)*/ path: "",
    code: "S41/S41W4002/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WEN826Q: {
    /*學生歷年服務時數及課外活動記錄(原WEN826)*/ path: "",
    code: "S41/S41W4003/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WEN825Q: {
    /*學生歷年操行成績查詢(原WEN825)*/ path: "",
    code: "S41/S41W4004/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WEN101Q: {
    /*歷年幹部查詢(原WEN101)*/ path: "",
    code: "S41/S41W4005/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WEN103Q: {
    /*畢業離校手續作業(Graduation Procedures)(原WEN103)*/ path: "",
    code: "S30/S30W2010/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WEN811Q: {
    /*新生資料調查作業(原WEN811)*/ path: "",
    code: "S43/S43W2003/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WEN845Q: {
    /*住宿生加扣點資料查詢(原WEN845)*/ path: "",
    code: "S43/S43W4008/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WEN9042Q: {
    /*歷年導師評量成績查詢(原WEN9042)*/ path: "",
    code: "S41/S419W4001/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WEN10A: {
    /*個人差勤查詢(for mweb)*/ path: "",
    code: "S18/S18W4001/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WEN107Q: {
    /*兼任主管調班假申請作業(原WEN107)*/ path: "",
    code: "S18/S18W2008/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WEN108Q: {
    /*職務代理資料一覽表(原WEN108)*/ path: "",
    code: "S18/S18W4002/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WEN109Q: {
    /*單位請假資料明細表(原WEN109)*/ path: "",
    code: "S18/S18W4003/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },

  WEN110Q: {
    /*教職員健檢補助申請作業(原WEN110)*/ path: "",
    code: "S16/S16W2001/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WEN113: {
    /*逾期假單補登申請作業 20251022*/ path: "",
    code: "S18/S18W2009/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  /* -------------------- 登錄/申請 End -------------------- */
  /* 每月薪資明細查詢列印 */
  WENZPG001: {
    path: "",
    code: "S1C/S1CW4001/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENZPG002: {
    path: "",
    code: "S1C/S1CW4002/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENZPG003: {
    path: "",
    code: "S1C/S1CW4003/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  ZCP408: "",
  ZCP410: "",
  WEN902Q: {
    /*教學助理評量(原WEN902)*/ path: "",
    code: "S70/S70W2001/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WEN922Q: {
    /*教師申請課程教學助理作業(原WEN922)*/ path: "",
    code: "S70/S70W2002/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WEN820A: {
    /**重大集會勤缺登記**/ path: "",
    code: "S41/S41W2002/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WEN820B: {
    /**重大集會勤缺登記 簽核**/ path: "",
    code: "S41/S41W9003/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  CK150: "",
  BK305: "",
  WENBG000: {
    path: "",
    code: "S33/S33W9001/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENZPE401: {
    path: "",
    code: "S18/S18W2001/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENZPE404: {
    path: "",
    code: "S18/S18W2003/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  ZPE412: "",
  ZPE499: "",
  ZPA404: "",
  WENZPE700: {
    path: "",
    code: "S14/S14W2001/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENZGP001: {
    path: "",
    code: "S20/S20W2001/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENZGP002: {
    path: "",
    code: "S20/S20W2002/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENBG200: {
    path: "",
    code: "S31/S31W2002/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENBG202: {
    path: "",
    code: "S47/S47W2001/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WEN311: { /*學分數低於下限申請 2025.11.20 for bing*/
    path: "",
    code: "S32/S32W2004/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WEN312: { /*學分數低於下限審核作業 2025.11.20 for bing*/
    path: "",
    code: "S32/S32W9001/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENBK230: {
    path: "",
    code: "S41/S41W9001/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENBK232: {
    path: "",
    code: "S41/S41W2003/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  ZWC406: "",
  WENBG052: {
    path: "",
    code: "S32/S32W2002/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENBK011: {
    path: "",
    code: "S32/S32W2003/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENZTB300: {
    path: "",
    code: "S51/S51W2001/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENZTB301: {
    path: "",
    code: "S51/S51W2003/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENZTB302: {
    path: "",
    code: "S51/S51W2002/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  /* ZTE300: '',
  ZTE301: '',
  ZTE302: '',
  ZTE303: '',
  ZTB300: '', */
  /* -------------------- 會計系統 Start -------------------- */
  WENZGD001: {
    path: "",
    code: "S20/S20W2013/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENZGD002: {
    path: "",
    code: "S20/S20W2014/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENZTF800: {
    path: "",
    code: "S20/S20W2003/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENZGC001: {
    path: "",
    code: "S20/S20W2010/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENZGC002: {
    path: "",
    code: "S20/S20W2011/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENZGA004: {
    path: "",
    code: "S20/S20W2006/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENZGA005: {
    path: "",
    code: "S20/S20W2007/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENZGA006: {
    path: "",
    code: "S20/S20W2008/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENZGC003: {
    path: "",
    code: "S20/S20W2012/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENZGA007: {
    path: "",
    code: "S20/S20W2009/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENZGA008: {
    path: "",
    code: "S20/S20W4001/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENZGA300: {
    path: "",
    code: "S20/S20W4002/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENZGA400: {
    path: "",
    code: "S20/S20W4003/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENZGA401: {
    path: "",
    code: "S20/S20W4004/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENZGA402: {
    path: "",
    code: "S20/S20W4005/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENZGA403: {
    path: "",
    code: "S20/S20W4006/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENZGH001: {
    path: "",
    code: "S20/S20W2015/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  /* -------------------- 會計系統 End -------------------- */
  /* -------------------- 會計系統 End -------------------- */

  ZGC001: "",
  ZGC002: "",
  ZGA004: "",
  ZGA005: "",
  ZGA006: "",
  ZGA007: "",
  WENZGT001: {
    path: "",
    code: "S20/S20W2005/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENZGA001: {
    path: "",
    code: "S20/S20W2004/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENZGF300: {
    path: "",
    code: "S49/S49W4001/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENZGF301: {
    path: "",
    code: "S49/S49W4002/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENZGF302: {
    path: "",
    code: "S49/S49W4003/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENAK470: {
    path: "",
    code: "S49/S49W4004/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENZJA807: {
    path: "",
    code: "S1Y/S1YW2001/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  ZJA850: "",
  ZKA001: "",
  ZKA100: "",
  WEN301Q: {
    path: "",
    code: "S55/S55W4003/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENSIGN001: {
    path: "",
    code: "S1Y/S1YW9001/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENZPC001: {
    path: "",
    code: "S20/S20W9001/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WENZPC004: {
    path: "",
    code: "S18/S18W9001/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  ZPS400: "",
  WEN30W2009: {
    path: "",
    code: "S30/S30W2009/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WEN30W4001: {
    path: "",
    code: "S30/S30W4001/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  WEN870: "",
  /* -------------------- 選課 Start -------------------- */
  "0WENAG203": {
    path: "",
    code: "S32/S32W1005/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  "0WEN0A0011": {
    path: "",
    code: "S33/S33W2001/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  "0WEN0A0012": {
    path: "",
    code: "S33/S33W2002/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  "0WEN0A002": {
    path: "",
    code: "S33/S33W2003/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  "0WEN0A003": {
    path: "",
    code: "S33/S33W4001/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  "0WEN0A004": {
    path: "",
    code: "S33/S33W2004/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  "0WEN0A005": {
    path: "",
    code: "S33/S33W2005/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  "0WEN0A006": {
    path: "",
    code: "S33/S33W4002/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  "0WEN0A007": {
    path: "",
    code: "S33/S33W2006/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  "0WEN0A010": {
    path: "",
    code: "S33/S33W2007/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  "0WEN0A011": {
    path: "",
    code: "S33/S33W2008/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  "0WEN0A012": {
    path: "",
    code: "S33/S33W4003/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  "0WEN0A013": {
    path: "",
    code: "S33/S33W4004/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  "0WEN0B001": {
    path: "",
    code: "S33/S33W2009/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  "0WEN0B002": {
    path: "",
    code: "S33/S33W2010/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  "0WEN0B003": {
    path: "",
    code: "S33/S33W4005/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  "0WEN0E000": {
    path: "",
    code: "S32/S32W1005/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  "0WEN0E001": {
    path: "",
    code: "S33/S33W2012/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  "0WEN0E002": {
    path: "",
    code: "S33/S33W2013/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  "0WEN0E003": {
    path: "",
    code: "S33/S33W4007/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  "0WEN0E004": {
    path: "",
    code: "S33/S33W4008/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  "0WEN0M001": {
    path: "",
    code: "S33/S33W2011/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  "0WEN0M002": {
    path: "",
    code: "S33/S33W4006/Views/index",
    iconName: "",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  },
  /* -------------------- 選課 End -------------------- */
};

export function routerMapping(array, pages) {
  Array.prototype.groupBy = function (prop) {
    return this.reduce(function (groups, item) {
      const val = item[prop];
      groups[val] = groups[val] || [];
      groups[val].push(item);
      return groups;
    }, {});
  };

  pages = pages == 'index' ? '/' : `/${pages}/`;
  var r = [
    {
      path: pages,
      name: "layout",
      meta: {
        code: "layout/Layout",
        remark: "home",
      },
      children: [],
    },
  ];
  const mdlList = array.groupBy("mdl_id");
  //console.log(mdlList);
  Object.entries(mdlList).forEach(([mdlKey, mdlValue]) => {
    const untList = mdlValue.groupBy("unt_id");
    let mdl = menuFilter(pages, mdlValue[0], 1);

    Object.entries(untList).forEach(([untKey, untValue]) => {
      let unt = menuFilter(pages, untValue[0], 2);

      untValue.forEach((fncValue) => {
        let fnc = menuFilter(pages, fncValue, 3);
        // 隱藏未完成第3層
        if (fnc.meta.code === "PageNotFound") {
          return;
        }

        if (process.env.VUE_APP_ENV === "development" || process.env.VUE_APP_ENV === "rd") {
          unt.children.push(fnc);
        } else if ((process.env.VUE_APP_ENV === "production" || process.env.VUE_APP_ENV === "test") && (fnc.id.slice(0, 3) == "WEN" || fnc.id.slice(0, 4) == "0WEN")) {
          unt.children.push(fnc);
        }
      });

      // 隱藏未完成第2層
      if (unt.children.length > 0) {
        mdl.children.push(unt);
      }
    });

    // 隱藏未完成第1層
    if (mdl.children.length > 0) {
      r[0].children.push(mdl);
    }
  });
  //console.log(r);
  return r;
}

export function menuFilter(pages, resp, layer) {
  const isDefaultLang = i18n.locale == "tw";
  let parentId = null,
    id = null,
    displayName = null;
  let dictResp = {
    path: "/Sample/",
    code: "Sample/Sample",
    iconName: "iconfont icon-web-setting",
    element: "",
    routeParam: "",
    remark: "",
    hidden: "",
  };

  switch (layer) {
    case 1:
      id = resp.mdl_id;
      displayName = isDefaultLang ? resp.mdl_name : resp.mdl_name_en;
      dictResp = layer1[id];
      break;
    case 2:
      parentId = resp.mdl_id;
      id = resp.unt_id;
      displayName = isDefaultLang ? resp.unt_name : resp.unt_name_en;
      dictResp = layer2[id];
      break;
    case 3:
      parentId = resp.unt_id;
      id = resp.func_id;
      displayName = isDefaultLang ? resp.fnc_name : resp.fnc_name_en;
      dictResp = layer3[id];
      break;
  }

  let isSet = dictResp !== undefined && dictResp !== "";
  const layer2Code = "layout/components/AppMain/Layer2Views";

  return {
    id: id,
    parentId: parentId,
    path: isSet && dictResp.path !== "" ? dictResp.path : layer == 1 ? `${pages}${resp.mdl_id}` : layer == 2 ? `${pages}${resp.mdl_id}/${resp.unt_id}` : `${pages}${resp.mdl_id}/${resp.unt_id}/${resp.func_id}`,
    name: id,
    meta: {
      id: id,
      layer: layer,
      name: id,
      code: isSet && dictResp.code !== "" ? dictResp.code : layer == 1 ? "Sample/Sample" : layer == 2 ? layer2Code : "PageNotFound",
      iconName: isSet && dictResp.iconName !== "" ? dictResp.iconName : "iconfont icon-web-setting",
      element: isSet && dictResp.element !== "" ? dictResp.elements : "",
      routeParam: isSet && dictResp.routeParam !== "" ? dictResp.routeParam : "",
      remark: isSet && dictResp.remark !== "" ? dictResp.remark : displayName,
    },
    hidden: isSet && dictResp.hidden !== "" ? dictResp.hidden : "",
    children: [],
  };
}

export default {
  getLayer3() {
    return layer3;
  },
};
